module.exports = __webpack_public_path__ + "officialStatic/img/developmentBg.95bb3d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/developmentBg.png
// module id = Cl+H
// module chunks = 0